export default __webpack_public_path__ + "static/bg-tablet-blog-d930264759e2f103edeb940a01637d16.png";